import styles from './VacanciesPage.module.scss'
import { Link, useNavigate } from "react-router-dom"
import { useIsAuth } from '../../hooks/auth'
import { useCallback, useEffect, useState } from "react"
import useGetVacancies from '../../hooks/vacancies/useGetVacancies'
import VacancyCard from '../../components/VacancyCard/VacancyCard'
import { useIsVisible } from '../../hooks/common'
import LoadingModal from '../../ui/LoadingModal/LoadingModal'
import Button from '../../ui/Button/Button'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import StarIcon from '@mui/icons-material/Star';
import clsx from 'clsx'
import { FILTERS_URL } from '../../utils'

type TVisited = "all" | "visited" | "new" | "favourite"

const VacanciesPage = () => {
  const [pages, setPages] = useState(1)

  const { data: isAuth } = useIsAuth()
  const [visited, setVisited] = useState<TVisited>(localStorage.getItem("visited-settings") as TVisited || 'all')

  useEffect(() => {
    if (isAuth === false) {
      setVisited('all')
    }
  }, [isAuth])

  useEffect(() => {
    localStorage.setItem("visited-settings", visited)
    window.scrollTo({top: 0})
    setPages(1)
  }, [visited])

  const { vacancies, isLoading, total: vacanciesTotal } = useGetVacancies(pages, visited)

  const onShow = useCallback(() => {
    setTimeout(() => {
      setPages(cur => cur + 1)
    }, 100)
  }, [])
  useIsVisible(
    "vacancies-border",
    onShow
  )


  return (
    <div className={styles.root}>
      <div className={styles.upperPanel}>
        <div className={styles.visited}>
          {isAuth 
          ?
            <>
              <Button kind={visited === "all" ? "red" : "white"} onClick={() => {setVisited("all")}}>Все</Button>
              <Button kind={visited === "new" ? "red" : "white"} onClick={() => {setVisited("new")}}>Новые</Button>
              <Button kind={visited === "visited" ? "red" : "white"} onClick={() => {setVisited("visited")}}><VisibilityOffIcon/></Button>
              <Button kind={visited === "favourite" ? "red" : "white"} onClick={() => {setVisited("favourite")}}><StarIcon/></Button>
            </>       
          :
            <>
              <h3>Фильтры станут доступны после <Link to={FILTERS_URL}>авторизации</Link></h3>
            </>   
          }

        </div>
        {vacanciesTotal?.value !== 0 
        ? 
          <p className={clsx([styles.vacanciesCount, "small"])}>
            {vacanciesTotal?.relation === 'eq'
            ?
              <>{vacanciesTotal?.value} вакансии</>
            :
              <>Более {vacanciesTotal?.value} вакансий</>
            }
          </p>
        :
          <>
            {isLoading
            ? <p className={clsx([styles.vacanciesCount, "small"])}>Загрузка</p>
            : <p className={clsx([styles.vacanciesCount, "small"])}>Ничего не найдено</p>
            }
          </>
        
        }
      </div>
      <div className={styles.vacancies}>
        {vacancies?.map(vacancy => (
          <VacancyCard
            key={vacancy.id}
            vacancy={vacancy}
            className={styles.vacancy}
          />
        ))}
      </div>
      <div id="vacancies-border" className={styles.border} />
      {isLoading && <LoadingModal />}
    </div>
  )
}

export default VacanciesPage